<div class="w-full"
>
  <div
    class="h-[3.437rem] w-[100%] !bg-[#CFD4DA] pl-[2.1rem] flex items-center sticky-tab-panel"
  >
    <div class="flex justify-between w-[100%]">
      <h5 class="title">{{ projectName }} - Expression Of Interest</h5>
      <img
        src="assets/icons/cross-icon.svg"
        (click)="closeDialog()"
        alt="cross icon"
        class="cursor-pointer pr-[1.3125rem]"
      />
    </div>
  </div>
  <div class="w-full"
  id="InitiateEoi"
  >
  <div class="container mt-[0.5rem]">
    <div class="flex justify-end items-center mx-[40px]">
      <div class="flex items-center gap-[10px]">
  <button (click)="print()" class="print-button mr-[0.5rem]">Print</button>
        <img
          src="assets/images/logo.png"
          alt="logo"
          class="h-[65px] w-[65px] rounded-[7px]"
        />
      </div>
    </div>
  <div
      class="header h-[55px] flex justify-start items-center pl-[14px] mt-[10px] bg-[#F1F3F5]"
    >
      <p class="!m-0 pl-[1.5625rem]">Project Brief</p>
    </div>
   <div class="px-[1.6875rem] mt-[0.8rem]">
     <app-brief-section></app-brief-section>
   </div>

     <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[1.2rem] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0 pl-[1.5rem]">Selected Work Packages</p>
      </div>
      <div class="px-[1.6875rem]">
      <div class="w-[50%] mt-[7px] ml-[14px]">
        <div
          *ngFor="
            let orgDetail of data?.submittedInitiation?.selected_work_packages;
            let i = index
          "
          class="w-[100%] !h-[49px] flex justify-between items-center"
        >
          <div class="flex justify-start">
            <img
              src="assets/icons/checkbox.png"
              class="h-[20px] w-[20px] mr-[12px]"
              alt="checkbox"
            />
            <p class="!text-[#343A40]">{{ orgDetail?.name }}</p>
          </div>
        </div>
      </div>
     </div>

       <div
        class="header h-[55px] flex justify-start items-center pl-[14px] mt-[60px] mb-[18px] bg-[#F1F3F5]"
      >
        <p class="!m-0 pl-[1.5rem]">Eligibility Criteria</p>
      </div>
        <div class="px-[1.6875rem]">
      <div class="w-[100%] mt-[7px] ml-[12px]">
        <div class="w-[100%] flex justify-between items-center">
          <div class="flex justify-start">
            <p
              class="!text-[#21252A]"
              [innerHTML]="
                getSanitizedHtml(data?.submittedInitiation?.eligibility_criteria)
              "
            ></p>
          </div>
        </div>
      </div>
      </div>
        <div class="px-[1.6875rem]">
        <div class="w-[100%] mt-[7px] ml-[12px]">
     
      <div
      class="flex justify-between w-[400px]"
      *ngIf="data?.submittedInitiation?.submission_date"
    >
      <p class="eoi-date">EOI Submission Closing</p>
      <p class="eoi-date-value">
        {{ transformDate(data?.submittedInitiation?.submission_date) }}
      </p>
    </div>
    <div
      class="flex justify-between w-[400px]"
      *ngIf="data?.submittedInitiation?.inquiry_deadline"
    >
      <p class="eoi-date">EOI Deadline</p>
      <p class="eoi-date-value">
        {{ transformDate(data?.submittedInitiation?.inquiry_deadline) }}
      </p>
    </div>
  </div>

    <div class="mx-[1rem] mt-[2rem]">
      <!-- applicant detail -->

      <div class="flex justify-between items-center w-72 h-8 !mt-5">
        <h4 class="section-title">Applicant Details</h4>
      </div>
      <!-- NOTE: Spacing utilities are based on a 4-pixel unit scale, so gap-y-6 corresponds to a vertical gap of 24 pixels. -->
      <div class="grid grid-cols-3 gap-y-6 mt-[10px]">
        <div class="flex flex-col">
          <p class="header-attribute">Company Name</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.company_name }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Contact Person</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.contact_person }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Company Registration Number</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.company_reg_no }}
          </p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Position</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.contact_person_position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">VAT Registration Number</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.company_vat_no }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Email</p>
          <p class="header-attribute-value">{{ eoiResponseData?.email }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Website</p>
          <p class="header-attribute-value">{{ eoiResponseData?.website }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Telephone</p>
          <p class="header-attribute-value">{{ eoiResponseData?.phone }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Address</p>
          <p class="header-attribute-value">{{ eoiResponseData?.address }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">City</p>
          <p class="header-attribute-value">{{ eoiResponseData?.city }}</p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Country</p>
          <p class="header-attribute-value">
            {{ countryName ? countryName : "" }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">State/Province</p>
          <p class="header-attribute-value">{{ eoiResponseData?.state }}</p>
        </div>

        <div class="flex flex-col">
          <p class="header-attribute">Zip Code</p>
          <p class="header-attribute-value">{{ eoiResponseData?.zip }}</p>
        </div>
        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!-- Experience & Capability (If Applicable) -->

      <div class="flex justify-start items-center mt-[50px]">
        <h4 class="section-title">Experience & Capability(If Applicable) </h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 mt-[10px]">
        <div class="flex flex-col">
          <p class="header-attribute">Relevant Experience</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.relevant_experience }}
          </p>
          <app-attachment-list 
            [attachments]="eoiResponseData?.relevant_experience_attachments"
            [config]="{ fileNameKey: 'title', filePathKey: 'file_path' }">
          </app-attachment-list>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Key Qualifications</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.qualifications }}
          </p>
          <app-attachment-list 
            [attachments]="eoiResponseData?.key_qualifications_attachments"
            [config]="{ fileNameKey: 'title', filePathKey: 'file_path' }">
          </app-attachment-list>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Team Composition</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.team_composition }}
          </p>
          
            <app-attachment-list 
              [attachments]="eoiResponseData?.team_composition_attachments"
              [config]="{ fileNameKey: 'title', filePathKey: 'file_path' }">
            </app-attachment-list>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!--  Compliance & Policies -->

      <div class="flex justify-start items-center mt-[50px]">
        <h4 class="section-title">Compliance & Policies</h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 mt-[10px]">
        <div class="flex flex-col">
          <p class="header-attribute">Health, Safety & Environmental Policy</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.health_safety_environmental_policy }}
          </p>
          <app-attachment-list 
              [attachments]="eoiResponseData?.health_and_safety_attachments"
              [config]="{ fileNameKey: 'title', filePathKey: 'file_path' }">
            </app-attachment-list>
          
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Quality Assurance Certification</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.quality_assurance_cert_attach }}
          </p>
          <app-attachment-list 
              [attachments]="eoiResponseData?.quality_assurance_attachments"
              [config]="{ fileNameKey: 'title', filePathKey: 'file_path' }">
            </app-attachment-list>
          
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Conflict of Interest Disclosure</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.conflict_of_interest }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>

      <!--  Additional Information -->

      <div
        *ngIf="eoiResponseData?.additional_information"
        class="flex justify-start items-center mt-[50px]"
      >
        <h4 class="section-title">Additional Information</h4>
      </div>
      <p class="header-attribute-value" style="margin-top: 20px !important">
        {{ eoiResponseData?.additional_information }}
      </p>

      <app-attachment-list 
              [attachments]="eoiResponseData?.additional_info_attach"
              [config]="{ fileNameKey: 'title', filePathKey: 'file_path' }">
            </app-attachment-list>
      <!--   Declaration -->

      <div class="flex justify-start items-center mt-[50px]">
        <h4 class="section-title">Declaration</h4>
      </div>
      <div class="grid grid-cols-3 gap-y-6 mt-[10px] mb-[40px]">
        <div class="flex flex-col">
          <p class="header-attribute">Name of Authorized Representative</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.authorized_representative }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Position</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.authorized_representative_position }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Signature</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.signature }}
          </p>
        </div>
        <div class="flex flex-col">
          <p class="header-attribute">Date</p>
          <p class="header-attribute-value">
            {{ eoiResponseData?.date | date : "yyyy-MM-dd" }}
          </p>
        </div>

        <!-- Empty cells -->
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
</div>
